import { useCallback, useEffect, useState } from "react";
import { CheckCircle2, History } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { dtt } from "./shared";

export function AlarmLog({ plantId }) {
  const [rows, setRows] = useState([]);
  const [nota, setNota] = useState({});
  const load = useCallback(() => api.get("/vesta/comunicazioni/allarmi", { params: { plant_id: plantId } }).then((r) => setRows(r.data.allarmi)).catch(() => {}), [plantId]);
  useEffect(() => { load(); }, [load]);
  if (!rows.length) return null;
  const close = async (a) => {
    try { await api.post(`/vesta/comunicazioni/allarmi/${a.id}/chiudi`, { nota: nota[a.id] || "" }); toast.success("Allarme registrato come gestito"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Errore"); }
  };
  return (
    <section className="space-y-2" data-testid="alarm-log">
      <div className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-widest text-neutral-400"><History className="h-3.5 w-3.5" />Storico allarmi gestiti</div>
      {rows.map((a) => (
        <div key={a.id} className="rounded-lg border border-neutral-800 p-2.5 text-xs" data-testid={`alarm-log-${a.id}`}>
          <div className="flex items-center gap-2"><b className="text-white">{a.livello} · {a.desc}</b><span className="ml-auto text-neutral-500">{dtt(a.opened_at)}</span></div>
          {a.closed_at ? <div className="mt-1 flex items-start gap-1.5 text-neutral-400"><CheckCircle2 className="mt-0.5 h-3.5 w-3.5 shrink-0 text-emerald-400" />Chiuso {dtt(a.closed_at)} da {a.closed_by}: {a.nota}</div> : (
            <div className="mt-2 flex gap-2">
              <input value={nota[a.id] || ""} onChange={(e) => setNota({ ...nota, [a.id]: e.target.value })} placeholder="Nota di chiusura…" className="min-w-0 flex-1 rounded-md border border-neutral-800 bg-transparent px-2 py-1 text-xs text-white outline-none focus:border-[#C17F59]" data-testid={`alarm-log-nota-${a.id}`} />
              <button type="button" onClick={() => close(a)} className="rounded-full border border-emerald-500/50 px-3 py-1 font-bold text-emerald-300 hover:bg-emerald-500/10" data-testid={`alarm-log-close-${a.id}`}>Chiudi</button>
            </div>)}
        </div>))}
    </section>
  );
}
